import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ActivityState } from '@core/store';

export const selectActivityState = createFeatureSelector('activity');

export const getActivityInsertStatus = createSelector(
  selectActivityState,
  (state: ActivityState) => state.currentStatus
);
